export default __webpack_public_path__ + "static/media/grid_xd.ae43607a.svg";